import { AuthRoles, AuthUser } from "./Auth";
import { Customer } from "./Customer";
import { Provider } from "./Provider";

export type Manager = Omit<AuthUser, "fullName"> & {
  customerId: string | null;
  customer: Customer | null;

  providerId: string | null;
  provider: Provider | null;

  password?: string;
  phone: string | null;
  phoneCode: string | null;
  ipWhitelist: string[] | null;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};

export enum ManagerGroupsEnum {
  ADMIN = "admin",
  OTHERS = "others",
}

export const ManagerGroups = [
  {
    key: ManagerGroupsEnum.ADMIN,
    group: [AuthRoles.Admin],
  },
  {
    key: ManagerGroupsEnum.OTHERS,
    group: [
      AuthRoles.CustomerManager,
      AuthRoles.CustomerAgent,
      AuthRoles.ProviderAgent,
      AuthRoles.UnknownTelegramUser,
    ],
  },
];
